import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

/*
const initialValues = {
  grade: '',
  questions: [{ category: '', subcategory: '', text: '', yesNo: false, rating: '' }],
}; */

const ChooseTemplate = () => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [selectedSubcategorynames, setSelectedSubcategorynames] = useState([]);
  const [isKpiWeightageIncluded, setIsKpiWeightageIncluded] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategorynames, setSelectedCategorynames] = useState([]);
  const [questionsWeigtage, setquestionsWeigtage] = useState(null);
  const [kpiWeightage, setkpiWeightage] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);

  const [initialValues, setInitialValues] = useState({
    gradeid: "",
    questionsweigtage: "",
    kpiweightage: "",
    questions: [
      {
        category: "",
        categoryname: "",
        subcategory: "",
        subcategoryname: "",
        text: "",
        yesNo: false,
        rating: 0,
      },
    ],
  });
  const [options, setOptions] = useState([]);
  const [showSubcategories, setShowSubcategories] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [selgrade, setSelgrade] = useState(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tid = searchParams.get("tid");
  const validationSchema = Yup.object().shape({
    questionsweigtage: Yup.number()
      .required(
        "Questions Weightage is a required field. Please enter a value."
      )
      .min(0, "Must be at least 0")
      .max(100, "Must be at most 100"),
    kpiweightage: Yup.number()
      .min(0, "Must be at least 0")
      .test(
        "total-check",
        "There is an error. The weightage for questions and KPI together must be 100. Please correct the values and try again.",
        function (value) {
          const questionsweigtage = this.parent.questionsweigtage || 0;
          return !value || value + questionsweigtage <= 100;
        }
      ),
  });
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        if (tid) {
          const response = await axios.get(`${baseURL}/allgrades`);
          setOptions(response.data.grades);
        } else {
          const response = await axios.get(`${baseURL}/getnewgrades`);
          setOptions(response.data.grades);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        if (tid) {
          const response = await axios.get(
            `${baseURL}/gettemplatedetails?id=` + tid
          );
          let temp = response.data.template;
          let qjson = temp[0].questionsJSON;
          let tjson = JSON.parse(qjson);
          //setTemplate(tjson);
          setInitialValues(tjson);
          const categoryIds = tjson.questions.map((q) => q.category);
          const subcategoryIds = tjson.questions.map((q) => q.subcategory);

          // Set the selected categories and subcategories
          setSelectedCategories(categoryIds);
          setSelectedSubcategories(subcategoryIds);
          // Fetch subcategories for each category
          const subcatPromises = categoryIds.map((id) =>
            axios.get(`${baseURL}/getsubcategorieforcatid?parentid=${id}`)
          );
          const subcatResponses = await Promise.all(subcatPromises);
          const subcategoriesList = subcatResponses.map(
            (resp) => resp.data.subcategories
          );

          setIsKpiWeightageIncluded(tjson.isKpiWeightageIncluded);
          setquestionsWeigtage(tjson.questionsweigtage);
          setkpiWeightage(tjson.kpiweightage);
          setSubcategories(subcategoriesList);
          setSelgrade(temp[0].gradeid);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };
    fetchTemplate();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const resp = await axios.get(`${baseURL}/getcategories`);
        setCategories(resp.data.categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
    showSubcats();
  }, []);
  const showSubcats = async () => {
    try {
      //const resp = await axios.get("http://localhost:3050/getallsubcategories");
      //setSubcategories(resp.data.subcategories);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleSubmit = (values) => {
    console.log("selectedSubcategorynames", selectedSubcategorynames);
    // Include the selected categories and subcategories in the form data
    const updatedValues = {
      ...values,
      questions: values.questions.map((question, index) => ({
        ...question,
        category: selectedCategories[index] || question.category,
        categoryname: selectedCategorynames[index] || question.categoryname,
        subcategory: selectedSubcategories[index] || question.subcategory,
        subcategoryname:
          selectedSubcategorynames[index] || question.subcategoryname,
      })),
    };
    setFormData(updatedValues);
    setShowModal(true);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // setFieldValue(name, value);
  };

  const handlePrimaryCategoryChange = async (event, index) => {
    const { value } = event.target;
    const selval = event.target.selectedOptions[0].innerHTML;

    try {
      const resp = await axios.get(
        `${baseURL}/getsubcategorieforcatid?parentid=` + value
      );
      const newSubcategories = resp.data.subcategories;

      // Create a new array with updated subcategories for the specific index
      const updatedSubcategories = [...subcategories];
      updatedSubcategories[index] = newSubcategories;

      setSubcategories(updatedSubcategories);

      setSelectedCategories((prevCategories) => {
        const updatedCategories = [...prevCategories];
        if (!updatedCategories.length) {
          // Initialize the array with null values if it's not already initialized
          updatedCategories.length = initialValues.questions.length;
          updatedCategories.fill(null);
        }
        updatedCategories[index] = value; // Update the selected category at the specified index
        return updatedCategories;
      });

      setSelectedCategorynames((prevCategoryNames) => {
        const updatedCategoryNames = [...prevCategoryNames];
        if (!updatedCategoryNames.length) {
          // Initialize the array with null values if it's not already initialized
          updatedCategoryNames.length = initialValues.questions.length;
          updatedCategoryNames.fill(null);
        }

        // Ensure there is at least one selected option
        if (event.target.selectedOptions.length > 0) {
          // const catname = event.target.selectedOptions[0].innerHTML; // Get the innerHTML of the first selected option
          updatedCategoryNames[index] = selval;
          //alert(`Selected Category Name: ${selval}`);
        } else {
          console.warn("No selected options found");
        }

        return updatedCategoryNames;
      });
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleGradeChange = async (event) => {
    const { name, value } = event.target;
    setSelgrade(value);
  };
  const handleSubCategoryChange = (event, index) => {
    const { value } = event.target;

    console.log("Event Target:", event.target);
    console.log("Selected Options:", event.target.selectedOptions);

    setSelectedSubcategories((prevSubcategories) => {
      const updatedSubcategories = [...prevSubcategories];
      if (!updatedSubcategories.length) {
        // Initialize the array with null values if it's not already initialized
        updatedSubcategories.length = initialValues.questions.length;
        updatedSubcategories.fill(null);
      }

      updatedSubcategories[index] = value;
      return updatedSubcategories;
    });

    setSelectedSubcategorynames((prevSubcategorynames) => {
      const updatedSubcategorynames = [...prevSubcategorynames];
      if (!updatedSubcategorynames.length) {
        // Initialize the array with null values if it's not already initialized
        updatedSubcategorynames.length = initialValues.questions.length;
        updatedSubcategorynames.fill(null);
      }

      // Ensure there is at least one selected option
      if (event.target.selectedOptions.length > 0) {
        const catname = event.target.selectedOptions[0].innerHTML; // Assuming you want the innerHTML of the first selected option
        updatedSubcategorynames[index] = catname;
        //alert(`Selected Subcategory Name: ${catname}`);
      } else {
        console.warn("No selected options found");
      }

      return updatedSubcategorynames;
    });
  };

  const handleCloseModal = () => {
    setShowModal(false);
    const jsonData = JSON.stringify(formData);
    console.log(jsonData);
  };

  const handleConfirmSubmit = async () => {
    try {
      //formData.gradeid=selgrade;
      let jsonData = JSON.stringify(formData);
      if (tid) {
        const response = await fetch(
          `${baseURL}/updatetemplatemaster?tid=` + tid,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: jsonData,
          }
        );
        if (response.ok) {
          setFormData(null);
          setShowModal(false);
          setShowToast(true);
          setTimeout(() => {
            setShowToast(false);
            navigate("/createTemplateTab");
          }, 3000);

          // window.location.href = "/createTemplateTab";
        } else {
          console.error("Form submission failed:", response.statusText);
        }
      } else {
        const updatedQuestions = formData.questions.map((question, index) => {
          return {
            ...question,
            categoryname: selectedCategorynames[index] || question.categoryname, // Use the existing name if not provided
            subcategoryname:
              selectedSubcategorynames[index] || question.subcategoryname, // Use the existing name if not provided
          };
        });

        // Update formData with the new questions array
        const updatedFormData = {
          ...formData,
          questions: updatedQuestions,
        };


        // jsonData = JSON.stringify(formData);
        const userId = localStorage.getItem("userid"); // stored as a string

        const payload = {
          ...formData,
          user_id: userId,
        };
        const jsonData = JSON.stringify(payload);
        console.log("json data", jsonData);

        const response = await fetch(`${baseURL}/addtemplatemaster`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: jsonData,
        });
        console.log("inside handleConfirmSubmit ");

        if (response.ok) {
          setFormData(null);
          setShowModal(false);
          setShowToast(true);
          setTimeout(() => {
            setShowToast(false);
            navigate("/createTemplateTab");
          }, 3000);

          // window.location.href = "/createTemplateTab";
        } else {
          console.error("Form submission failed:", response.statusText);
        }
      }
      console.log("inside handleConfirmSubmit ");
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <div className="form-container">
      <h5>
        {tid
          ? " Edit Employee Appraisal Template:"
          : "Employee Appraisal Template Creation Procedure:"}
      </h5>
      <p>
        This is a <b>Appraisal template creation form for Grades</b>. First you
        need to select a grade name which you would have created. Selecting an
        existing grade which has appraisal submissions will not have the old
        questions
      </p>

      <Formik
        initialValues={initialValues}
        enableReinitialize
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="grade" className="pr-3">
                {tid ? "Selected Grade:" : "Step 1: Select Grade*:"}
              </label>
              <Field
                className="w-25 p-1"
                as="select"
                id="grade"
                name="grade"
                value={(values.gradeid = selgrade)}
                disabled={tid}
                onChange={(e) => handleGradeChange(e)}
              >
                <option value="">Select Grade</option>
                {options.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.gradename}
                  </option>
                ))}
              </Field>
            </div>
            <div className="form-field">
              <label htmlFor="grade" className="pr-3">
                {tid
                  ? "Weightage of questions :"
                  : "Step 2: Enter weightage of questions* :"}
              </label>
              <Field
                type="number"
                className="col-sm-1 p-1"
                required
                name="questionsweigtage"
                value={values.questionsweigtage || questionsWeigtage}
              />
            </div>
            <div className="form-field">
              <label htmlFor="grade" className="pr-3">
                {tid
                  ? "Weightage of KPI Questions :"
                  : "Step 3: Include KPI? Enter Weightage :"}
              </label>
              <Field
                type="radio"
                name="isKpiWeightageIncluded"
                value="yes"
                checked={isKpiWeightageIncluded === true}
                onChange={() => {
                  setIsKpiWeightageIncluded(true);
                  setFieldValue("isKpiWeightageIncluded", true);
                }}
              />{" "}
              Yes &nbsp;
              <Field
                type="radio"
                name="isKpiWeightageIncluded"
                value="no"
                checked={isKpiWeightageIncluded === false}
                onChange={() => {
                  setIsKpiWeightageIncluded(false);
                  setFieldValue("isKpiWeightageIncluded", false);
                  setFieldValue("kpiweightage", ""); // Clear the kpiweightage field
                }}
              />{" "}
              No
              <ErrorMessage
                name="questionsweigtage"
                component="div"
                className="field-error"
              />
              {isKpiWeightageIncluded && (
                <>
                  <Field
                    type="number"
                    className="col-sm-1 p-1"
                    required
                    name="kpiweightage"
                    value={values.kpiweightage || kpiWeightage}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="kpiweightage"
                    component="div"
                    className="field-error"
                  />
                </>
              )}
            </div>
            <label htmlFor="grade" className="pr-3">
              {tid
                ? "Edit Question Text and Marks"
                : "Step 4: Define Questions:"}
            </label>
            <table
              cellSpacing={2}
              cellPadding={2}
              className="appraisal-table w-100"
            >
              <thead>
                <tr>
                  <th>Primary Category</th>
                  <th>Subcategory</th>
                  <th>Enter Question[5000 Letters limit]</th>
                  <th>Rating</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <FieldArray name="questions">
                  {({ push, remove }) => (
                    <>
                      {values.questions.map((question, index) => (
                        <tr key={index}>
                          <td>
                            <Field
                              as="select"
                              value={
                                selectedCategories[index] || question.category
                              }
                              onChange={(e) =>
                                handlePrimaryCategoryChange(e, index)
                              }
                              name={`questions.${index}.category`}
                              className="category-select w-100 p-2"
                            >
                              <option value="">Select Category</option>
                              {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                  {category.categoryname}
                                </option>
                              ))}
                            </Field>
                          </td>
                          <td>
                            <Field
                              as="select"
                              name={`questions.${index}.subcategory`}
                              className="subcategory-select w-100 p-2"
                              value={
                                selectedSubcategories[index] ||
                                question.subcategory
                              }
                              onChange={(e) =>
                                handleSubCategoryChange(e, index)
                              }
                            >
                              <option value="">Select Subcategory</option>
                              {subcategories[index]?.map((subcategory) => (
                                <option
                                  key={subcategory.id}
                                  value={subcategory.id}
                                >
                                  {subcategory.subcategoryname}
                                </option>
                              ))}
                            </Field>
                          </td>
                          <td>
                            <Field
                              as="textarea"
                              className="form-control w-100"
                              name={`questions.${index}.text`}
                            />
                            <Field
                              hidden
                              type="checkbox"
                              name={`questions.${index}.yesNo`}
                            />
                          </td>

                          <td className="col-1">
                            <Field
                              type="text"
                              className="w-75 p-2"
                              name={`questions.${index}.rating`}
                            />
                          </td>
                          <td>
                            <button type="button" onClick={() => remove(index)}>
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="6">
                          <button
                            className="rounded fw-s border-0 bg-danger p-2 text-white"
                            type="button"
                            onClick={() =>
                              push({
                                category: "",
                                subcategory: "",
                                text: "",
                                yesNo: false,
                                rating: "",
                              })
                            }
                          >
                            <b>Add Question +</b>
                          </button>
                        </td>
                      </tr>
                    </>
                  )}
                </FieldArray>
              </tbody>
            </table>
            <div className="col-lg-11 text-end mt-4 pb-3">
              <Button
                className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                type="submit"
              >
                Save
              </Button>
              <a href="/createTemplateTab" className="text-decoration-none">
                <button
                  type="button"
                  className="btn cancelbtn ml-2"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </a>
            </div>
          </Form>
        )}
      </Formik>
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </div>
  );
};

export default ChooseTemplate;
